import moment from 'moment-timezone';
import { PnlDataVersion, SnapshotDatePreset, SnapshotDateRange } from 'src/components/star-grid/reportSelectors.types';
import { VERSION_DATE_PRESETS } from 'src/components/star-grid/versionDateFilterConstants';
import { isIcebergVersion } from 'src/components/star-grid/utils/versionAvailability';

export const snapshotDatePreset = (preset: SnapshotDatePreset, now = Date.now()): SnapshotDateRange => {
  if (preset === 'all') return { preset, startDate: '', endDate: '' };
  const today = moment.utc(now).startOf('day');
  const option = VERSION_DATE_PRESETS.find((item) => item.id === preset);
  const start =
    preset === 'month' ? today.clone().startOf('month') : today.clone().subtract(option && 'days' in option ? option.days - 1 : 0, 'days');
  return { preset, startDate: start.format('YYYY-MM-DD'), endDate: today.format('YYYY-MM-DD') };
};

export const isValidSnapshotDateRange = (range: SnapshotDateRange): boolean =>
  range.preset === 'all' ||
  (moment.utc(range.startDate, 'YYYY-MM-DD', true).isValid() &&
    moment.utc(range.endDate, 'YYYY-MM-DD', true).isValid() &&
    range.startDate <= range.endDate);

export const matchesSnapshotDateRange = (version: PnlDataVersion, range?: SnapshotDateRange): boolean => {
  if (!range || range.preset === 'all' || !isIcebergVersion(version)) return true;
  const date = moment.utc(version.as_of, moment.ISO_8601, true);
  if (!date.isValid()) return false;
  const day = date.format('YYYY-MM-DD');
  return day >= range.startDate && day <= range.endDate;
};

export const snapshotDateRangeLabel = (range: SnapshotDateRange): string => {
  if (range.preset === 'all' || !isValidSnapshotDateRange(range)) return '';
  const start = moment.utc(range.startDate);
  const end = moment.utc(range.endDate);
  return `${start.format(start.year() === end.year() ? 'MMM D' : 'MMM D, YYYY')} – ${end.format('MMM D, YYYY')}`;
};
